import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export function useIsElementPresent(
  elementId: string,
  recheck: boolean = false
) {
  const isPresentRef = ref(false);
  const route = useRoute();

  const checkFaq = () => {
    isPresentRef.value = !!document.getElementById(elementId);
  };

  onMounted(() => {
    checkFaq();

    if (recheck) {
      setTimeout(checkFaq, 1000);
    }
  });

  watch(() => route.fullPath, () => { checkFaq(); });

  const isPresent = computed(() => isPresentRef.value);

  return { isPresent };
}
